export * from './modal-config.interface';
